/**
 * ArchiveControl
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useApi2call } from 'containers/Api2/index.js';
import useDialog from 'containers/Dialog/useDialog.js';
import Icon2 from 'components/media/Icon2/index.js';
import doNothing from 'utils/doNothing.js';
import { dateString } from 'utils/timeFormat.js';
import messages from './messages.js';
import useArchive from './useArchive.js';

function ArchiveControl(props) {
  const { group } = props;
  const { id } = group;
  const { dlgPrompt, dlgConfirm } = useDialog();
  const api2call = useApi2call();
  const { handleUnarchive } = useArchive(group);

  function handleChangeDate() {
    dlgPrompt({ title: messages.changeDeleteDate, message: messages.newDate, type: 'date', value: dateString(group.deleteOn) })
      .then((date) => {
        const dateStr = `${date}T00:00:00.000Z`;
        api2call({
          method: 'PUT',
          url: `sa/groups/${id}/deleteOn`,
          selector: `sa/groups/archive/${id}`,
          body: dateStr,
          reducer: (state) => ({ ...state, deleteOn: new Date(dateStr) }),
          version: 2,
        });
      })
      .catch(doNothing);
  }

  function handleDeleteNow() {
    const message = { ...messages.confirmDeleteNow, values: { group: group.name } };
    dlgConfirm({ title: messages.deleteNow, message, confirmLabel: messages.delete, confirmStyle: 'danger' })
      .then(() => {
        api2call({
          method: 'DELETE',
          url: `sa/groups/${id}`,
          selector: `sa/groups/archive/${id}`,
          version: 2,
          success: messages.groupDeleted,
        });
      })
      .catch(doNothing);
  }

  const settingsIcon = <Icon2 className="ss-settings text-primary fs-4" />;
  return (
    <DropdownButton id="archiveControl" variant="link" align="end" aria-label="Dropdown" title={settingsIcon} className="no-caret">
      <Dropdown.Item as="button" eventKey="1" onClick={handleChangeDate}><FormattedMessage {...messages.changeDeleteDate} /></Dropdown.Item>
      <Dropdown.Item as="button" eventKey="2" onClick={handleUnarchive}><FormattedMessage {...messages.unarchive} /></Dropdown.Item>
      <Dropdown.Item as="button" eventKey="3" onClick={handleDeleteNow}><span className="text-danger"><FormattedMessage {...messages.deleteNow} /></span></Dropdown.Item>
    </DropdownButton>
  );
}

ArchiveControl.propTypes = {
  group: PropTypes.object,
};

export default ArchiveControl;
